export type IRulesModalResources = typeof RulesModalResources;

export const RulesModalResources = {
    legalInfo: [
        "Opuszczasz stronę goodie.pl. Na nowej stronie Partnera będziesz związany nowym Regulaminem i polityką prywatności.",
        "W zakresie oferty sprzedaży odpowiada Partner.",
    ],
    title: "Przechodzisz do sklepu",
    shortText: "Pamiętaj!",
    btnNext: "Przejdź",
    btnCancel: "Anuluj",
};
